<template></template>

<script>
export default {
  name: "Access",
  mounted() {
    this.$store.commit("showSpinner");
    this.access();
  },
  methods: {
    access() {
      let queryParametersFromAccess = this.$route.query;
      const campaignId = queryParametersFromAccess.campaign_id;
      const code = queryParametersFromAccess.c;
      const user = queryParametersFromAccess.u;
      this.$http
        .post(
          "/api/v1/campaigns/" +
            campaignId +
            "/users/access/" +
            code +
            "/" +
            user,
          {
            ...queryParametersFromAccess
          }
        )
        .then(response => {
          localStorage.setItem("token", response.data.data.token.access_token);
          this.$store.state.authorization.access_token =
            response.data.data.token.access_token;
          this.$http.defaults.headers.common["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$http.defaults.headers["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$store.state.authorization.expires_in =
            response.data.data.token.expires_in;

          this.$store.commit("hideSpinner");
          this.$router.push("/dashboard");
          window.location.replace("/dashboard");
        })
        .catch(error => {
          let errorResponse = error.response;
          switch (errorResponse.status) {
            case 422:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Dati non validi"),
                text: this.$i18n.t("Riprovare per favore")
              });
              break;
            case 404:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Utente non valido"),
                text: this.$i18n.t("Riprovare per favore")
              });
              break;
            default:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Errore")
              });
          }
          this.$store.commit("hideSpinner");
        });
    }
  }
};
</script>
